String.prototype.toCamelCase = function toCamelCase() {
    return this.split(' ').map(function (word, index) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
}

String.prototype.isNullOrEmpty = function isNullOrEmpty() {
    return this === null || this.trim() === '';
}